import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useDownloads } from "../../queries/downloadQueries";
import { showRequestErrorToast } from "../../services/ErrorService";
import { Loading } from "../loading/Loading";
import { hasAdjustedGradingSupplement } from "../../utils/DocumentHelpers";
import { GradeWindow } from "../adjusted-grading/GradeWindow";
import { AdjustedGradingInformation } from "../adjusted-grading/Information";
import { Documents } from "./Documents";
import { useVesselInspectionData } from "../../queries/particularsQueries";
import {
    useGrades,
    useInspectedGradeQuery
} from "../../queries/gradingQueries";

export const AdjustedGrading = () => {
    const { t } = useTranslation("locale");
    const { inspectionId } = useParams();
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);

    if (!inspectionId) {
        console.error("Documents - No inspection id.");
        showRequestErrorToast("Adjusted Grading - No inspection id.");
        return <div></div>;
    }

    /* eslint-disable react-hooks/rules-of-hooks -- TODO(A2-9305): the guard clause above returns before these hooks run */
    const { data, isError, isLoading, error } = useDownloads(
        inspectionId,
        user
    );

    const { data: vesselInspectionData, isLoading: vesselDataLoading } =
        useVesselInspectionData(inspectionId ?? "", user);

    const { data: gradeData, isLoading: gradeDataLoading } = useGrades(
        inspectionId,
        user
    );
    const { data: inspectedGrade } = useInspectedGradeQuery(
        inspectionId,
        vesselInspectionData?.IMONumber ?? "",
        vesselInspectionData?.isInspectionCopy ?? false
    );
    /* eslint-enable react-hooks/rules-of-hooks */

    if (
        isLoading ||
        vesselDataLoading ||
        gradeDataLoading ||
        data === undefined
    )
        return <Loading />;

    if (isError) {
        console.error(error);
        showRequestErrorToast("Documents");
        return <div></div>;
    }

    if (
        !hasAdjustedGradingSupplement(data.documents) ||
        !vesselInspectionData?.Grade ||
        !gradeData?.gradingInformation
    ) {
        return (
            <div className="flex align-items-center justify-content-center p-2">
                {t("adjustedGrading.no_adjusted_grading")}
            </div>
        );
    }

    return (
        <div className="grid">
            <div className="lg:col-8 col-12">
                <GradeWindow
                    gradeImageUrl={inspectedGrade?.imageUrl}
                    adjustedGradeImageUrl={
                        gradeData?.gradingInformation.adjustedGradeImageUrl
                    }
                />
            </div>
            <div className="lg:col-4 col-12">
                <AdjustedGradingInformation
                    grade={gradeData?.gradingInformation.adjustedOverallGrade}
                />
            </div>
            <div className="col-12">
                <Documents supplements adjustedTab />
            </div>
        </div>
    );
};
